import React from 'react';
import { motion } from 'framer-motion';
import { benefits } from '../data/content';
import { Sparkle } from './Sparkle';
export function Benefits() {
  return <section id="vorteile" className="relative w-full bg-cream px-4 py-10 sm:px-6 sm:py-12" data-id="element-49" data-mp="9d8rjc88uebp">
      <span aria-hidden="true" className="gold-glitter-layer-static" data-id="element-50" data-mp="4icntetna2ir" />
      <span aria-hidden="true" className="gold-glitter-extra" data-id="element-51" data-mp="3vpxmjz1li9g7" />
      <div className="relative z-10 mx-auto max-w-[1300px]" data-id="element-52" data-mp="3qs5i65jrkuv4">
        <div className="text-center" data-id="element-53" data-mp="3qpjdcdo9ctgl">
          <span className="mb-4 block text-xs font-semibold uppercase tracking-[0.25em] text-hot-500" data-id="element-54" data-mp="3mpiwynhlm86w">
            Deine Vorteile
          </span>
          <h2 className="font-heading text-3xl font-extrabold uppercase leading-tight text-neutral-900 sm:text-4xl" data-id="element-55" data-mp="3hr7pgjes09ru">
            Was macht die Hot Sales Girls Academy{' '}
            <span className="relative inline-block text-hot-500" data-id="element-56" data-mp="1fyjiq02xb47b">
              aus
              <Sparkle className="animate-sparkle-delayed -right-7 top-1/2 h-6 w-6 -translate-y-1/2 sm:-right-9 sm:h-8 sm:w-8" data-id="element-57" data-mp="1b087bkwzclmz" />
            </span>
          </h2>
        </div>

        <ul className="mt-8 grid gap-5 sm:grid-cols-2" data-id="element-58" data-mp="6st4dplwztt5">
          {benefits.map((benefit, i) => <motion.li key={benefit.title} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-80px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-col items-stretch gap-0 overflow-hidden rounded-3xl border border-hot-100 bg-hot-50 shadow-xl lg:flex-row lg:items-stretch" data-id="element-59" data-mp="3oyo0s8yg3he1" data-mpi={i}>
              <div className="flex flex-1 flex-col justify-center px-5 py-3 sm:px-6 sm:py-5 lg:p-7" data-id="element-60" data-mp="br348dil3il3">
                <h3 className="font-heading text-lg font-bold text-neutral-900" data-id="element-61" data-mp="gpo246ad5q6d">{benefit.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-neutral-600" data-id="element-62" data-mp="14eyxf88y2sd4">{benefit.text}</p>
              </div>
              <picture className="contents" data-id="element-63" data-mp="198l2ae8v9ryd">
                {benefit.imageMobile && <source media="(max-width: 639px)" srcSet={benefit.imageMobile} data-id="element-64" data-mp="1j2qn1fsp33yd" />}
                {benefit.imageDesktop && <source media="(min-width: 1024px)" srcSet={benefit.imageDesktop} type="image/webp" data-id="element-65" data-mp="194sx8nv6sz3n" />}
              <img src={benefit.image} alt={benefit.imageAlt} loading="lazy" decoding="async" style={{
              '--benefit-pos': benefit.imagePosition ?? 'center top',
              '--benefit-pos-mobile': benefit.imagePositionMobile,
              '--benefit-pos-tablet': benefit.imagePositionTablet,
              objectPosition: 'var(--benefit-pos-active)'
            } as React.CSSProperties} className={`benefit-img w-full shrink-0 rounded-b-3xl rounded-t-none object-cover sm:aspect-[4/3] lg:aspect-square lg:h-auto lg:w-56 lg:self-start lg:rounded-2xl xl:w-64 ${benefit.imageFullMobile ? 'aspect-square' : 'aspect-[4/3]'}`} data-id="element-66" data-mp="15491noq9i3jm" />
              </picture>
            </motion.li>)}
        </ul>
      </div>
    </section>;
}